import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { maintenanceConfig } from 'config/maintenanceConfig';
import useDialogConfirm from './DialogConfirm.hook';
import { MAINTENANCE } from 'types/dialogtypes';

const useMaintenanceDialog = () => {
	const { profile } = useSelector((store: RootState) => store.user);
	const confirmDialog = useDialogConfirm();

	useEffect(() => {
		if (profile && maintenanceConfig.enabled) {
			const now = dayjs();
			const start = dayjs(maintenanceConfig.startDate);
			const end = dayjs(maintenanceConfig.endDate);

			if (now.isAfter(start) && now.isBefore(end)) {
				confirmDialog.open(MAINTENANCE);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [profile]);
};

export default useMaintenanceDialog;
